import { gql } from 'graphql-request';
import { addEscapeCharacters } from '../helper/validations';

const GET_PROJECT_CASE = (orgId: string, projectId: string, versionId: string) => gql`
query GetProjectCase {
    case (
      org_id:${addEscapeCharacters(orgId)},
      project_id: ${addEscapeCharacters(projectId)},
      version_id: ${addEscapeCharacters(versionId)},
    ) {
        code
        name
        base
        total_cost
      }
}`;

export default { GET_PROJECT_CASE };
